import React from "react";
import { Spin } from "antd";
import { LoadingPage } from "../images";

export const ScreenLoading = () => {
  return (
    <div className="wrap-full-screen">
      <Spin
        indicator={
          <img src={LoadingPage} style={{ height: 80, width: "auto" }} />
        }
      />
    </div>
  );
};
